<app-base-container [page]="true" pageTitle="Schedule History" [hasBackButton]="true">
  @if (config) {
    <rspl-history [config]="config" />
  }
</app-base-container>
